import { Chip, Stack, Tooltip, Typography } from '@mui/material';
import type { StyleObj } from '../../@types';
import type { Withdrawal } from '../../@types/api';
import { getWithdrawalDisplay } from '../../helpers/paymentDisplay';
import { mergeSx } from '../../utils/styles';

const styles: StyleObj = {
  root: { flexDirection: 'row', alignItems: 'center', gap: 1, height: '100%' },
  label: { typography: { xs: 'body3', md: 'body2' } },
};

const statusColor = (color: string): StyleObj[string] => ({ color });

const WithdrawalStatusCell = ({ withdrawal }: { withdrawal: Withdrawal }) => {
  const { statusLabel, statusTone, notice } = getWithdrawalDisplay(withdrawal);

  return (
    <Stack sx={styles.root}>
      {/* The notice comes first so a non-wrapping, narrow cell never clips it. */}
      {notice && (
        <Tooltip title={notice.hint}>
          <Chip size='small' color='warning' label={notice.label} aria-label={notice.hint} />
        </Tooltip>
      )}
      <Typography sx={mergeSx(styles.label, statusColor(statusTone))}>{statusLabel}</Typography>
    </Stack>
  );
};

export default WithdrawalStatusCell;
